import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { money } from '../lib/format.js';

export default function Reports() {
  const year = new Date().getFullYear();
  const [from, setFrom] = useState(`${year}-01-01`);
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
  const { data: vat } = useQuery({ queryKey: ['vat-report', from, to], queryFn: () => api(`/api/reports/vat?from=${from}&to=${to}`) });
  const { data: rev } = useQuery({ queryKey: ['rev-report', from, to], queryFn: () => api(`/api/reports/revenue?from=${from}&to=${to}&groupBy=month`) });
  return (
    <>
      <div className="page-header">
        <h1>Reports</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
          <input type="date" value={to} onChange={e => setTo(e.target.value)} />
          <a className="btn btn-secondary" href="/api/reports/export/invoices.csv" download>Export invoices CSV</a>
          <a className="btn btn-secondary" href="/api/reports/export/payments.csv" download>Export payments CSV</a>
        </div>
      </div>
      <div className="card">
        <h2>VAT summary ({from} → {to})</h2>
        <table className="table">
          <thead><tr><th>VAT %</th><th style={{ textAlign: 'right' }}>Net</th><th style={{ textAlign: 'right' }}>VAT</th></tr></thead>
          <tbody>
            {vat?.rows?.map(r => (
              <tr key={r.vatPct}><td>{r.vatPct.toFixed(2)}%</td>
                <td style={{ textAlign: 'right' }}>{money(r.net)}</td>
                <td style={{ textAlign: 'right' }}>{money(r.vat)}</td></tr>
            ))}
            {vat && (
              <tr><td><strong>Total</strong></td>
                <td style={{ textAlign: 'right' }}><strong>{money(vat.netTotal)}</strong></td>
                <td style={{ textAlign: 'right' }}><strong>{money(vat.vatTotal)}</strong></td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="card">
        <h2>Revenue by month</h2>
        <table className="table">
          <thead><tr><th>Period</th><th style={{ textAlign: 'right' }}>Total</th></tr></thead>
          <tbody>
            {rev?.rows?.map(r => (
              <tr key={r.period}><td>{r.period}</td><td style={{ textAlign: 'right' }}>{money(r.total)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
